import { textStyles } from '@cosuno/cosuno-ui';
import styled from 'styled-components';

export const CellContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 100%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  ${textStyles.labelMedium500};
`;
export const Description = styled.div`
  text-align: center;
  width: 300px;
  ${textStyles.bodyMedium450};
`;
